import gql from 'graphql-tag'

export default gql`
    mutation resetPassword($code: String!, $newPassword: String!, $confirmPassword: String!){
      resetPassword(code: $code, newPassword: $newPassword, confirmPassword: $confirmPassword)
    }
`